import React from "react"
import { MessageSquare, Package, X } from "lucide-react"
import { motion } from "framer-motion"
import styles from "./PublicationTypeSelector.module.scss"
import ModalOverlay from "../ModalOverlay/ModalOverlay.tsx"

const modal = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { delay: 0.1 },
  },
}

interface PublicationTypeSelectorProps {
  onSelectType: (type: "simple" | "product") => void
  onClose: () => void
  userData: {
    image_profile: string
    name: string
    last_name?: string
    razon_social?: string
    type: string
  }
}

export default function PublicationTypeSelector({ onSelectType, onClose, userData }: PublicationTypeSelectorProps) {
  const fullName = userData.type === "COMPANY" ? userData.razon_social : `${userData.name} ${userData.last_name || ""}`

  return (
    <ModalOverlay isOpen={true} onClose={onClose}>
      <motion.div
        variants={modal}
        initial="hidden"
        animate="visible"
        exit="hidden"
        className={styles.modal}
      >
          <div className={styles.content}>
            <div className={styles.header}>
              <div className={styles.header_userInfo}>
                <img
                  src={userData.image_profile || "/placeholder.svg?height=40&width=40"}
                  alt="profile"
                  className={styles.header_avatar}
                />
                <div>
                  <div className={styles.header_name}>{fullName}</div>
                  <div className={styles.header_subtitle}>Visible por todos</div>
                </div>
              </div>
              <button className={styles.header_closeButton} onClick={onClose}>
                <X size={20} />
              </button>
            </div>

            <h2 className={styles.title}>¿Qué deseas publicar?</h2>

            <div className={styles.options}>
              <button className={styles.optionButton} onClick={() => onSelectType("simple")}>
                <div className={`${styles.optionButton_icon} ${styles.simple}`}>
                  <MessageSquare size={24} />
                </div>
                <div className={styles.optionButton_content}>
                  <div className={styles.optionButton_title}>Publicación simple</div>
                  <div className={styles.optionButton_description}>Comparte texto, imágenes o videos</div>
                </div>
              </button>

              <button className={styles.optionButton} onClick={() => onSelectType("product")}>
                <div className={`${styles.optionButton_icon} ${styles.product}`}>
                  <Package size={24} />
                </div>
                <div className={styles.optionButton_content}>
                  <div className={styles.optionButton_title}>Producto o Servicio</div>
                  <div className={styles.optionButton_description}>Publica con detalles, precios y ubicación</div>
                </div>
              </button>
            </div>
          </div>
      </motion.div>
    </ModalOverlay>
  )
}
